import React, { useState } from 'react'; 
import { useAuth } from '../utils/AuthContext/AuthContext';
import { useNavigate, Link } from 'react-router-dom';

import MainCard from '../components/MainCard';

function About() {

return (
        <div className="w-full h-full md:h-[750px] md:w-[750px] flex flex-col justify-center items-center">
            <MainCard>
            <div className="container mx-auto p-8">
      <header className="flex flex-col items-start mb-12">
        <h1 className="text-xl md:text-3xl md:font-bold text-black font-inter">Colorado First</h1>
        <p className="text-md md:text-xl mt-2 md:mt-4">Given the sweeping changes going on in the industry, we will be starting in the Colorado market.</p>
      </header>

      <header className="flex flex-col items-start mb-12">
        <h1 className="text-xl md:text-3xl md:font-bold text-black font-inter">Our Mission is to Create Agency</h1>
        <p className="text-md md:text-xl mt-2 md:mt-4">There used to be a dream in America called home ownership. It's what caused many to seek an opportunity in a distant land, perhaps someone from your own family tree. <br/><br/>Home ownership is becoming 
        more difficult with each passing year and along with it that once strongly held dream by so many before us. Shishito's mission is to level the playing field, return the power to the dreamer in each of us, and allow you to be your own agent.</p>
      </header>
      
      <section className="mb-12">
        <h2 className="text-lg md:text-2xl font-semibold mb-4 text-black">Contact Us</h2>
        <p className="text-md md:text-lg">Email: info@shishito-re.com</p>
      </section>
      
      <footer className="text-center mt-12">
      <div className="mt-4">
          <a href="https://facebook.com" className="mx-2">Facebook</a>
          <a href="https://twitter.com" className="mx-2">Twitter</a>
          <a href="https://linkedin.com" className="mx-2">LinkedIn</a>
        </div>
        {/* <p className="text-lg">Interested in joining our team? <a href="/careers" className="text-blue-500">Learn more</a></p> */}
      </footer>
    </div>
            </MainCard>
        </div>
 
    );
}

export default About;